import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import axios from "axios";
import moment from "moment/moment";
import { IoMdArrowRoundBack } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import styles from "./MerchantReport.module.scss";
import { handleLogout } from "../../../../redux/features/userSlice";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./style.css";

export default function MerchantReport() {
  const girdRef = useRef();
  const [gridApi, setGridApi] = useState("");

  const token = useSelector((state) => state.cpc.user.login.token);

  const dispatch = useDispatch();

  const [columnDefs, setColumnDefs] = useState([
    {
      headerName: "Business Name",
      field: "Business Name",
      flex: 2,
    },
    {
      headerName: "Activation Date",
      field: "Activation Date",
    },
    {
      headerName: "Total Scanned Codes",
      field: "Total Scanned Codes",
    },
    {
      headerName: "Total Rewards ( EGP )",
      field: "Total Rewards",
      cellRenderer: (result) => {
        return <div>{result.data["Total Rewards"]} EGP</div>;
      },
    },
  ]);

  const onGridReady = (params) => {
    setGridApi(params.api);
    axios
      .post(
        "https://evouchers.shareecoin.com/CPC/getReports",
        {
          reportType: "branch activation",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.statusCode === 200) {
          const result = Object.values(res.data.assignedMerchants);
          params.api.applyTransaction({ add: result });
        }
        if (res.data.statusCode === 401) {
          dispatch(handleLogout());
          navigate("/cpc/login");
        }
      });
  };

  const defaultColDef = {
    flex: 1,
    sortable: true,
    filter: true,
    floatingFilter: false,
    minWidth: 200,
  };

  const navigate = useNavigate();

  const { t } = useTranslation();

  const handleExport = () => {
    gridApi.exportDataAsCsv();
  };

  return (
    <div className={`${styles.MerchantReportContent}`}>
      <Container fluid>
        <Row>
          <Col xs={12} md={6} className="mb-3">
            <h3 className={`${styles.teamTitle} mb-3 mb-md-0`}>
              <IoMdArrowRoundBack
                className={`${styles.backBtn} fs-4 me-2`}
                onClick={() => {
                  navigate("/admin/dashboard/merchants/all");
                }}
              />
              {t("reportMerchants")}
            </h3>
          </Col>
          <Col xs={12}>
            <div
              className="ag-theme-alpine"
              style={{ width: "100%", height: `70vh` }}
            >
              <AgGridReact
                ref={girdRef}
                onGridReady={onGridReady}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                pagination={true}
                paginationAutoPageSize={true}
              />
            </div>
          </Col>
          <Col xs={12} className="my-3 text-center">
            <Button
              variant="primary"
              className={`${styles.downloadBtn}`}
              onClick={() => {
                handleExport();
              }}
            >
              {t("downloadReport")}
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
